<template>
  <!--  ************ HOME EURETE **********  -->
  <!-- Mostra l'insieme delle sezioni in cui si dividono i prodotti Eurete -->
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!--CARD PRINCIPALE DI CONTENIMENTO DELLA HOME -->
      <b-card title="ExAnte Mutua" sub-title="Offerte mutualistiche per le tue esigenze">
        <!-- ELENCO DELLE SEZIONI IN CUI SI DIVIDONO I PRODOTTI -->
        <b-row class="mt-3" v-for="( row_elem, index ) in parted_sez" :key="index" >
            <b-col class="text-center" v-for="( col_elem, index ) in row_elem" :key="index" :cols="calculate_bootstrap_col_class(parted_sez)">
              <b-link class="sez-link" @click="visualizza_sezione(col_elem.slug_name)">
                <div class="mt-3 sez-badge">
                  <b-img fluid :src="get_url_icona( col_elem.icona )" :alt="col_elem.nome"></b-img>
                  <h6 class="mt-3">{{col_elem.nome}}</h6>
                </div>
              </b-link>
            </b-col>
        </b-row>
      </b-card>
    </CustomOverlay>
    <!-- Disclaimer per l'accettazione delle condizioni circa le informazioni -->
    <!-- da dare sui parenti e circa il fatto che questi acquisti scalano dal -->
    <!-- monte credito relativo all'art51c3 -->
    <DisclaimerCondizioni/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import DisclaimerCondizioni from '@/components/eurete/DisclaimerCondizioni'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'HomeEurete',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "ExAnte Mutua", link : 'conv-eurete-buoni' } ],
      overlay_show: false,

      // Array delle sezioni
      sezioni : []
    }
  },
  computed : {
    /**
     * Ripartisce le sezioni in un'array di array di modo tale da avere
     * sez_by_row elementi per ogni sotto array e cioè sez_by_row elementi
     * per ogni riga.
     */
    parted_sez : function () {
      return generalLib.sub_array_partition( this.sezioni, this.sez_by_row );
    }
  },
  methods : {
    /**
     * Wrapper per la funzione di libreria omonima, senza il wrapper non potrei
     * richiamarla direttamente dal template.
     * Data un'array partizionata calcola la giusta classe boostrap da dare alle
     * colonne per spaziare adeguatamente il contenuto.
     */
    calculate_bootstrap_col_class : function ( parted_array ) {
      return generalLib.calculate_bootstrap_col_class( parted_array );
    },
    /**
     * Al click sull'immagine della sezione visualizza il contenuto della stessa.
     *
     * - slug_name: slug_name della sezione che dobbiamo visualizzare
     */
    visualizza_sezione : function ( slug_name ) {
      this.$router.push( { name : 'sez-eurete', params : { slug_name : slug_name } } );
    },
    /**
     * Dal nome dell'icona della sezione torna l'url per la stessa
     */
    get_url_icona : function ( nome_icona ) {
        // L'unione tra il path e il nome dell'icona deve essere
        // fatto direttamente dentro il require e non in una variabile,
        // perchè altrimenti webpack non saprebbe quali moduli includere
        // se il path è una variabile. Includendo invece parte del path
        // in modo statico sa cosa deve includere.
        // https://stackoverflow.com/questions/44673258/vuejs-cannot-find-module
        return require( '@/assets/eurete/' + nome_icona );
    }
  },
  /**
   * Carichiamo i le sezioni in cui si dividono i prodotti Eurete al carimento della pagina
   */
  created : function () {

    this.overlay_show = true;

    // Per il momento visualizziamo tutte le sezioni quindi non usiamo il paginatore,
    // pertanto usiamo il solo parametro page_size impostandolo a 1000 cioè il massimo
    // numero di elementi ospitabili in una pagina usando il paginatore specifico
    // di welfarebit
    let params = { page_size : 1000 , id_categ: 53 };

    axios.get( apiUrl.eureteapi.get_sezioni, { params: params } )
    .then( ( response ) => {

      this.sezioni = response.data.results;
      this.overlay_show = false;

    })
    .catch( ( error ) => {
        this.overlay_show = false;
        let message = "Si è verificato un errore nel caricamento delle informazioni, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
    });
  },
  props : {
    /**
     * Numero massimo di sezioni da visualizzare per ogni riga
     */
    sez_by_row: {
      type: Number,
      default: 4,
      validator: function (value) {
        // Non possiamo ospitare più di 12 elementi per riga.
        // Cioè le 12 colonne consentite da bootstrap.
        return value <= 12;
      }
    }
  },
  components: {
    PageTagline,
    CustomOverlay,
    DisclaimerCondizioni
  }

}
</script>

<style scoped>
/* Css dei badge per mostrare le sezioni */
.sez-link {
  text-decoration: none;
  color: #000000;
}

.sez-badge {
  border : 1px solid rgba(0,0,0,.125);
  border-radius: 10px;
  padding: 10px 10px 10px 10px;
  background: #ffffff;
}
.sez-badge:hover {
  filter: blur(1px);
}

</style>